import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'check_delete_department_possibility';
export const useConfirmImpossibilityOfDepartmentDeletionTranslation = ():
UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Невозможно удалить подразделение',
    description: 'Подразделение является владельцем групп / списков или у него есть дочерние подразделения.',
    submit: 'Понятно',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Unable to delete department',
    description: 'The department owns groups / lists or has child departments.',
    submit: 'Got it',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'No se puede eliminar la subdivisión',
    description: 'La subdivisión es propietaria de grupos / listas o tiene subdivisiones secundarias.',
    submit: 'Entendido',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Não é possível excluir o departamento',
    description: 'O departamento é proprietário de grupos / listas ou possui departamentos subordinados.',
    submit: 'Entendi',
  },
}) as Record<string, unknown>;
